import { render, staticRenderFns } from "./UserPanel.vue?vue&type=template&id=7a1960e2&scoped=true"
import script from "./UserPanel.vue?vue&type=script&lang=js"
export * from "./UserPanel.vue?vue&type=script&lang=js"
import style0 from "./UserPanel.vue?vue&type=style&index=0&id=7a1960e2&prod&scoped=true&lang=scss"
import style1 from "./UserPanel.vue?vue&type=style&index=1&id=7a1960e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1960e2",
  null
  
)

export default component.exports